import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import LeadCard from "@/components/base/LeadCard";
import { leads } from "@/mocks/leads";

export default function LatestLeads() {
  const featured = leads.slice(0, 6);

  return (
    <section className="w-full bg-background-50 py-16 md:py-24" aria-labelledby="latest-leads">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <SectionHeading
              id="latest-leads"
              eyebrow="最新线索"
              title="正在征集的热门线索"
              description="以下线索均处于征集阶段，若你掌握相关时间、地点或材料，欢迎前往线索广场了解详情并提交补充。"
            />
            <Link
              to="/leads"
              className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              进入线索广场
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((lead, index) => (
            <Reveal key={lead.id} delay={index * 60}>
              <LeadCard lead={lead} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}